import { render, staticRenderFns } from "./PermissionDenided.vue?vue&type=template&id=9290bfb4&scoped=true"
import script from "./PermissionDenided.vue?vue&type=script&lang=js"
export * from "./PermissionDenided.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9290bfb4",
  null
  
)

export default component.exports